import { createRouter, createWebHistory } from 'vue-router';
import CarrierInformation from './views/CarrierInformation.vue';
import CarrierChanges from './views/CarrierChanges.vue';
import CoverageInfo from './views/CoverageInfo.vue';
import CoverageChanges from './views/CoverageChanges.vue';
import MainLayout from '../layouts/MainLayout.vue';
import DriversInfo from './views/DriversInfo.vue';
import DriversChanges from './views/DriversChanges.vue';
import EquipmentInfo from './views/EquipmentInfo.vue';
import EquipmentChanges from './views/EquipmentChanges.vue';
import SubmitChanges from './views/SubmitChanges.vue';
import FinishChanges from './views/FinishChanges.vue';
const routes = [
  
  {
    path: '/',
    component: MainLayout,
    children: [
      {
        path: '',
        component: CarrierInformation,
        meta: { title: 'Carrier Information', step: 1 }
      }
    ]
  },
  {
    path: '/carrierchanges',
    component: MainLayout,
    children: [
      {
        path: '',
        component: CarrierChanges,
        meta: { title: 'Carrier Information', step:1 }
      }
    ]
  },
  {
    path: '/coverageinfo',
    component: MainLayout,
    children: [
      {
        path: '',
        component: CoverageInfo,
        meta: { title: 'Coverage', step: 2 }
      }
    ]
  },
  {
    path: '/coveragechanges',
    component: MainLayout,
    children: [
      {
        path: '',
        component: CoverageChanges,
        meta: { title: 'Coverage', step: 2 }
      }
    ]
  },
  {
    path: '/driversinfo',
    component: MainLayout,
    children: [
      {
        path: '',
        component: DriversInfo,
        meta: { title: 'Drivers', step: 3 }
      }
    ]

  },
  {

    path: '/driverschanges',
    component: MainLayout,
    children: [
      {
        path: '',
        component: DriversChanges,
        meta: { title: 'Drivers', step: 3 }
      }
    ]

  },
  {

    path: '/equipmentinfo',
    component: MainLayout,
    children: [
      {
        path: '',
        component: EquipmentInfo,
        meta: { title: 'Equipment', step: 4  }
      }
    ]
  },
  {

    path: '/equipmentchanges',
    component: MainLayout,
    children: [
      {
        path: '',
        component: EquipmentChanges,
        meta: { title: 'Equipment', step: 4  }
      }
    ]

  },
  {

    path: '/submitchanges',
    component: MainLayout,
    children: [
      {
        path: '',
        component: SubmitChanges,
        meta: { title: 'Almost Done!', step: 5  }
      }
    ]

  },
  {

    path: '/finishchanges',
    component: MainLayout,
    children: [
      {
        path: '',
        component: FinishChanges,
        meta: { title: 'Thank You!', step: 6  }
      }
    ]

  }
  

];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;